import { IconWrapper } from '../runtime';
export default IconWrapper('log', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8 5.99976C8.55229 5.99976 9 5.55204 9 4.99976C9 4.44747 8.55229 3.99976 8 3.99976C7.44772 3.99976 7 4.44747 7 4.99976C7 5.55204 7.44772 5.99976 8 5.99976Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M7.20996 7.74982H7.70996C7.9861 7.74982 8.20996 7.97367 8.20996 8.24982V11.2498M8.20996 11.2498H7.20996M8.20996 11.2498H9.20996M13.25 5.12083C13.25 4.72301 13.092 4.34148 12.8107 4.06017L10.9393 2.18885C10.658 1.90755 10.2765 1.74951 9.87868 1.74951H4.25C3.42157 1.74951 2.75 2.42108 2.75 3.24951V12.7495C2.75 13.5779 3.42157 14.2495 4.25 14.2495H11.75C12.5784 14.2495 13.25 13.5779 13.25 12.7495V5.12083Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});